import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import building from "../assets/building.jpg";

export default function Hero() {
  return (
    <section className="relative flex min-h-[100vh] items-end overflow-hidden">
      {/* Background Image */}
      <img
        src={building}
        alt="Современное строительство"
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

      {/* Content */}
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-20 sm:px-6 lg:px-8 lg:pb-28">
        <div className="max-w-4xl">
          <p className="mb-5 text-sm font-semibold uppercase tracking-[0.3em] text-primaryBlue">
            Строительство жилых домов
          </p>

          <h1 className="mb-8 max-w-4xl text-5xl leading-[1.04] tracking-[-0.055em] text-white md:text-6xl lg:text-7xl xl:text-[88px]">
  <span className="block font-semibold">
    Ваш дом —
  </span>
  <span className="block font-light text-white/95">
    наша ответственность.
  </span>
</h1>

          <p className="mb-10 max-w-2xl text-lg leading-relaxed text-white/80 md:text-xl">
            Мы проектируем и строим продуманные жилые дома, объединяя
            современную архитектуру, проверенные материалы и высокий стандарт
            исполнения — от идеи до передачи ключей.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-3 rounded-sm bg-primaryBlue px-8 py-4 font-semibold text-white transition-all duration-300 hover:bg-primaryBlue/90"
            >
              Начать проект
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>

            <Link
              to="/projects"
              className="inline-flex items-center rounded-sm border border-white/50 px-8 py-4 font-semibold text-white transition-all duration-300 hover:border-white hover:bg-white hover:text-slate-950"
            >
              Наши проекты
            </Link>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-16 hidden lg:flex flex-wrap gap-10 text-white md:gap-14">
          <div>
            <div className="text-4xl font-semibold">15+</div>
            <div className="mt-2 text-sm uppercase tracking-[0.25em] text-white/60">
              Лет опыта
            </div>
          </div>

          <div>
            <div className="text-4xl font-semibold">120+</div>
            <div className="mt-2 text-sm uppercase tracking-[0.25em] text-white/60">
              Проектов
            </div>
          </div>

          <div>
            <div className="text-4xl font-semibold">100%</div>
            <div className="mt-2 text-sm uppercase tracking-[0.25em] text-white/60">
              Ответственность
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}